import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LeadStateRequest, LeadStateResponse, PageResponse } from '../models/lead-state.model';

@Injectable({
  providedIn: 'root'
})
export class LeadStateApiService {
  private readonly apiUrl = `${environment.apiUrl}api`;

  constructor(private http: HttpClient) { }

  // GET /api/lead-states?businessId=&page=&size=
  getStates(businessId: number, page = 0, size = 100): Observable<LeadStateResponse[]> {
    const params = new HttpParams()
      .set('businessId', businessId.toString())
      .set('page', page.toString())
      .set('size', size.toString());
    return this.http.get<PageResponse<LeadStateResponse>>(`${this.apiUrl}/lead-states`, { params })
      .pipe(map(res => res.content));
  }

  // GET /api/lead-states/{id}?businessId=
  getStateById(id: number, businessId: number): Observable<LeadStateResponse> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.get<LeadStateResponse>(`${this.apiUrl}/lead-states/${id}`, { params });
  }

  // POST /api/lead-states
  createState(state: LeadStateRequest): Observable<LeadStateResponse> {
    return this.http.post<LeadStateResponse>(`${this.apiUrl}/lead-states`, state);
  }

  // PUT /api/lead-states/{id}
  updateState(id: number, state: LeadStateRequest): Observable<LeadStateResponse> {
    return this.http.put<LeadStateResponse>(`${this.apiUrl}/lead-states/${id}`, state);
  }

  // DELETE /api/lead-states/{id}?businessId=
  deleteState(id: number, businessId: number): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.delete<void>(`${this.apiUrl}/lead-states/${id}`, { params });
  }

  // POST /api/lead-states/reorder?businessId= — body: ids en el nuevo orden (lista COMPLETA).
  // El backend asigna display_order por posición empezando en 1. Responde 204 sin body.
  reorderStates(businessId: number, orderedIds: number[]): Observable<void> {
    const params = new HttpParams().set('businessId', businessId.toString());
    return this.http.post<void>(`${this.apiUrl}/lead-states/reorder`, orderedIds, { params });
  }
}
